import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PoundOutlinedSvg from "@ant-design/icons-svg/es/asn/PoundOutlined";
import AntdIcon from '../components/AntdIcon';
var PoundOutlined = function PoundOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: PoundOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  PoundOutlined.displayName = 'PoundOutlined';
}
export default /*#__PURE__*/React.forwardRef(PoundOutlined);